import { createReducer, Action, on, createFeatureSelector } from '@ngrx/store';
import * as actions from './job-details.actions';
import { AppState } from '../app.state';

export interface State {
  loading: boolean;
  loaded: boolean;
  error: any;
  job: string;
}

export const initialState: State = {
  loaded: false,
  loading: false,
  error: null,
  job: null,
};

const jobDetailsReducer = createReducer(
  initialState,
  on(actions.loadJobDetails, (state, { job }) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    // Keep the current job's data on screen while it refreshes. Blanking it
    // up front means a *failed* refresh leaves an empty page -- and the
    // common case for that is resuming right after unlock, while the network
    // is still reassociating. The user then sees an empty gallery with no
    // way back except the refresh button. Only clear when switching jobs.
    job: state.job === job ? state.job : null,
  })),
  on(actions.loadJobDetailsFailure, state => ({
    ...state,
    loading: false,
    // `job` is deliberately left as-is: whatever was on screen stays there.
  })),
  on(actions.loadJobDetailsSuccess, (state, { job }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    job,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return jobDetailsReducer(state, action);
}

export const selectJobDetails = createFeatureSelector<State>('jobDetails');
